import navigation from '@plone/volto/reducers/navigation/navigation';
import { runtimeConfig } from '@plone/volto/runtime_config';
import { resolveLook } from '../Look/look';
import { menuFor, menuItems } from './menu';

export const SET_LOOK = 'ASAJ_SET_LOOK';
export const setLook = (look) => ({ type: SET_LOOK, look });

const itemsFor = (look) =>
  menuItems(menuFor(resolveLook(look, runtimeConfig.RAZZLE_DEFAULT_LOOK)));

// Volto's navigation reducer, with the menu from ./menu in place of the
// page tree. Desktop tabs and the phone drawer both read state.navigation,
// so they show the same menu; it follows the visitor's look (LookSync tells
// the store which one). Whatever @navigation returns is ignored, which
// also means the tree no longer needs fetching below the top level.
export default function asajNavigation(state, action) {
  if (action.type === SET_LOOK) {
    return { ...state, look: action.look, items: itemsFor(action.look) };
  }
  const next = navigation(state, action);
  if (next === state || next.items === state?.items) return next;
  return { ...next, look: state?.look, items: itemsFor(state?.look) };
}
